// gameData.js

// This defines the structure of a full game session, including levels and guesses.

const generateSessionId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `sess_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
};

export const createNewGame = (hardMode = false) => ({
  didWin: false,               // Did the player win this game?
  timestamp: Date.now(),       // When the game started
  sessionId: generateSessionId(),
  hardMode: hardMode,          // true or false
  levels: []                   // Filled as the player progresses
});

export function createNewLevel(levelNumber, answer, hardMode = false) {

  const guessesAllowed = !hardMode
    ? 6
    : levelNumber === 0
      ? 4
      : levelNumber === 1
        ? 5
        : 6;

  return {
    level: levelNumber,
    answer: answer,
    guessesAllowed: guessesAllowed,
    guesses: [],
    completed: false,
    crackedOnGuess: null,
    levelStartTime: Date.now(),
    levelEndTime: null,
  };
}

export function addLevelToGame(game, levelNumber, answer, hardMode = false) {
  const newLevel = createNewLevel(levelNumber, answer, hardMode);

  return {
    ...game,
    levels: [...game.levels, newLevel]
  };
}

export const createNewGuess = (guessArray, feedbackArray) => ({
  guess: [...guessArray],        // Example: ['2', '6', '9', 'A', 'B']
  feedback: [...feedbackArray]   // Example: ['green', 'yellow', 'grey', 'grey', 'green']
});

export function addGuessToLevel(game, guessObj) {
  const updatedLevels = [...game.levels];
  const currentLevel = updatedLevels[updatedLevels.length - 1];

  const updatedGuesses = [...currentLevel.guesses, guessObj];

  const crackedOnGuess = guessObj.feedback.every(f => f === 'green')
    ? updatedGuesses.length
    : currentLevel.crackedOnGuess ?? null;

  const updatedLevel = {
    ...currentLevel,
    guesses: updatedGuesses,
    crackedOnGuess,
    completed: crackedOnGuess !== null
    //guessesUsed: updatedGuesses.length
  };

  updatedLevels[updatedLevels.length - 1] = updatedLevel;

  return {
    ...game,
    levels: updatedLevels
  };
}

export function finalizeLevel(level) {
  const guesses = level.guesses || [];

  const crackedIndex = guesses.findIndex(
    g => g.feedback.every(f => f === 'green')
  );

  return {
    ...level,
    crackedOnGuess: crackedIndex >= 0 ? crackedIndex + 1 : null,
    completed: crackedIndex >= 0,
    //guessesUsed: guesses.length,
    levelEndTime: Date.now()
  };
}

export function finalizeGame(game, didWin) {
  const totalGuessesUsed = game.levels.reduce((sum, level) => {
    return sum + (level.guesses.length || 0);
  }, 0);

  const totalGuessesAllowed = game.levels.reduce((sum, level) => {
    return sum + (level.guessesAllowed || 0);
  }, 0);

  return {
    ...game,
    didWin,
    timestamp: Date.now(),
    totalGuessesUsed,
    totalGuessesAllowed
  };
}
